import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import type { ApplyCloseTemplateEntitySelectionRow } from "../applyCloseTemplateEntitySelection.types";
import { ApplyCloseEntityDateCell } from "./ApplyCloseEntityDateCell";

export const ApplyCloseEntityStartDateCell = memo(
    function ApplyCloseEntityStartDateCell({
        row,
    }: CellContext<
        ViewTableFeatures,
        ApplyCloseTemplateEntitySelectionRow,
        string
    >) {
        return (
            <ApplyCloseEntityDateCell
                row={row}
                field="startDate"
                addText="Add start date"
                placeholder="Start date..."
            />
        );
    },
);
